import { createReducer, on } from '@ngrx/store';
import { Contenido } from 'src/common/contenido';
import * as DetalleActions from './detalle.actions';


export interface DetalleState {
	detalleRidSelected: string;
	detalle: Contenido;
	ready: boolean;
}

const initialDetalleState: DetalleState = {
	detalleRidSelected: null,
	detalle: null,
	ready: true
};

export const detalleReducer = createReducer(
	initialDetalleState,
	// Detalle actions
	on( DetalleActions.detalleRequested, ( state, { contenidoRid } ) => ( { ...state, detalleRidSelected: contenidoRid, detalle: null, ready: false } ) ),
	on( DetalleActions.detalleLoaded, ( state, { detalle } ) => ( { ...state, detalle, ready: true } ) ),
	on( DetalleActions.detalleCancelled, state => initialDetalleState ),
	on( DetalleActions.detalleCleared, state => initialDetalleState ),
	// Reporte emergencia action
	on( DetalleActions.detalleEmergenciaRequested, state => ( { ...state, ready: false } ) )
);
